import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, { ripple: "" }, {
    prepend: _withCtx(() => [
      _createVNode(_component_ontos_color_accent, {
        vertical: "",
        color: _ctx.optionColorOf(_ctx.item),
        class: "ontos-rel-accent-list"
      }, null, 8, ["color"])
    ]),
    _: 1
  }))
}